import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { AiManagementState } from 'store/modules/ai_management_store/types';
import { setFilters } from 'store/modules/ai_management_store/actions';
import ExternalRoutes from 'services/external_routes';
import { Container } from './styles';

interface AiManagementAnalyzeEmptyProps {
  teamCount: number;
}

const AiManagementAnalyzeEmpty: React.FC<AiManagementAnalyzeEmptyProps> = ({ teamCount }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector<ApplicationState, AiManagementState>(
    (state) => state.session.ai_management,
  );

  const memberFilterActive = filters.scope === 'mine' || filters.memberIds.length > 0;
  const showTeam = memberFilterActive && teamCount > 0;

  const handleShowTeam = () => {
    dispatch(setFilters({ ...filters, scope: null, memberIds: [] }));
  };

  return (
    <Container className="text-center rounded p-3">
      <p className="font-weight-bold text-dark mb-2">
        Você ainda não está analisando nenhuma licitação
      </p>
      <p className="text-muted mb-0">
        Acesse o <Link to={ExternalRoutes.boletins}>Boletim</Link> e o{' '}
        <Link to={ExternalRoutes.licitacoes}>Encontrar Licitações</Link> para ver oportunidades
      </p>

      {showTeam && (
        <>
          <div className="team-chip rounded-pill border text-muted mt-3 px-3 py-2">
            Sua equipe tem {teamCount} {teamCount === 1 ? 'licitação' : 'licitações'} em análise
          </div>
          <button
            type="button"
            className="btn btn-link p-0 mt-2 team-link"
            onClick={handleShowTeam}
          >
            Gostaria de mudar seu filtro para ver licitações de toda a equipe?
          </button>
        </>
      )}
    </Container>
  );
};

export default AiManagementAnalyzeEmpty;
